/**
 * @param {any} str
 * @returns {boolean}
 */
export function isString(str) {
    return typeof str === 'string' || str instanceof String;
}
/**
 * @param {any[]} arr
 * @returns {string}
 */
export function stringifyArray(arr) {
    return arr.reduce((acc, curr) => {
        return (acc += JSON.stringify(curr));
    }, '');
}
//# sourceMappingURL=string.js.map